<template>
  <span>
    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 47"
      :src="require('@/assets/img/mapa/INF/INF-A-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 48"
      :src="require('@/assets/img/mapa/INF/INF-A-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 49"
      :src="require('@/assets/img/mapa/INF/INF-A-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 50"
      :src="require('@/assets/img/mapa/INF/INF-A-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 51"
      :src="require('@/assets/img/mapa/INF/INF-A-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 52"
      :src="require('@/assets/img/mapa/INF/INF-A-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 53"
      :src="require('@/assets/img/mapa/INF/INF-A-3-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 54"
      :src="require('@/assets/img/mapa/INF/INF-A-3-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 55"
      :src="require('@/assets/img/mapa/INF/INF-A-3-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 56"
      :src="require('@/assets/img/mapa/INF/INF-B-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 57"
      :src="require('@/assets/img/mapa/INF/INF-B-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 58"
      :src="require('@/assets/img/mapa/INF/INF-B-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 59"
      :src="require('@/assets/img/mapa/INF/INF-B-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 60"
      :src="require('@/assets/img/mapa/INF/INF-B-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 61"
      :src="require('@/assets/img/mapa/INF/INF-B-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 62"
      :src="require('@/assets/img/mapa/INF/INF-i-1-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 63"
      :src="require('@/assets/img/mapa/INF/INF-i-1-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 64"
      :src="require('@/assets/img/mapa/INF/INF-i-1-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 65"
      :src="require('@/assets/img/mapa/INF/INF-i-2-I.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 66"
      :src="require('@/assets/img/mapa/INF/INF-i-2-II.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>

    <v-img
      v-if="perguntaObj.percentual.percentualAtingido > 67"
      :src="require('@/assets/img/mapa/INF/INF-i-2-III.png')"
      v-bind:class="{ 'image-content': perguntaObj.pergunta, 'image-content-complete': !perguntaObj.pergunta }"
    >
    </v-img>
  </span>
</template>

<script>
export default {
  props: {
    perguntaObj: { type: Object, required: true }
  }
}
</script>
